<app-pageheader [Parent]="this">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="valet/keyaudits/searches"
  [AllowEdit]="true" EditUrl="/valet/keyaudits/:id" [UseQueryParamStates]="true">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-date-filter DateSearchProperty="AuditedAt"></div>
    <div app-valetstations-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>
